import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs, { Dayjs } from "dayjs";

interface subscriptionPaymentFilterState {
  startDate: string;
  endDate: string;
  membershipType: string;
  paymentStatus: string;
}

const initialState: subscriptionPaymentFilterState = {
  startDate: "",
  endDate: "",
  membershipType: "",
  paymentStatus: "",
};

// Load from localStorage if exists
const savedFilters = localStorage.getItem("subscriptionPaymentFilters");
const persistedState = savedFilters
  ? {
      ...initialState,
      ...JSON.parse(savedFilters),
      // Convert ISO strings back to Dayjs
      startRange: JSON.parse(savedFilters)?.startRange
        ? dayjs(JSON.parse(savedFilters)?.startRange)
        : null,
      endRange: JSON.parse(savedFilters)?.endRange
        ? dayjs(JSON.parse(savedFilters)?.endRange)
        : null,
    }
  : initialState;

const subscriptionPaymentFilterSlice = createSlice({
  name: "subscriptionPaymentFilter",
  initialState: persistedState,
  reducers: {
    setSubscriptionPaymentFilter(
      state,
      action: PayloadAction<Partial<subscriptionPaymentFilterState>>
    ) {
      Object.assign(state, action.payload);
      localStorage.setItem("subscriptionPaymentFilter", JSON.stringify(state));
    },
    resetSubscriptionPaymentFilter() {
      localStorage.removeItem("subscriptionPaymentFilter");
      return initialState;
    },
  },
});

export const { setSubscriptionPaymentFilter, resetSubscriptionPaymentFilter } =
  subscriptionPaymentFilterSlice.actions;

export default subscriptionPaymentFilterSlice.reducer;
